/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import LeafletMap from 'components/common/map/LeafletMap';

const FireIncidentsMap = ({ data, coordinates }) => {
  return (
    <Card className="h-100">
      <FalconCardHeader title={data?.title} titleTag="h5" light={true} />
      <Card.Body className="h-100 p-0" dir="ltr">
        <LeafletMap
          data={{ coordinates, mapData: data }}
          className="h-100 bg-white"
          style={{ minHeight: '400px' }}
          key={`${data.key}-fire-land-locations`}
        />
      </Card.Body>
      <Card.Footer className="bg-white py-0 card-footer-style">
        <h5 className="mb-0 infrence-info">{data.info}</h5>
      </Card.Footer>
    </Card>
  );
};

FireIncidentsMap.propTypes = {
  data: PropTypes.object
};

export default FireIncidentsMap;
